import {
  Shift,
  ShiftProviderState,
} from '../../../contexts/ShiftProvider.types';

export type TScenarioDetailModel = {
  id: string;
  startDate: string;
  endDate: string;
  shiftLength: number | string;
  providerType: string;
  providerCount: number;
  hours: number;
};
export interface ITableFilterParams {
  shiftLength?: TScenarioDetailModel['shiftLength'];
  providerType?: TScenarioDetailModel['providerType'];
  selectedDay?: number | '';
}
export default class ScenarioDetailModel {
  data: TScenarioDetailModel[] = [];
  constructor(res?: Shift[]) {
    this.data =
      res
        ?.map?.((each) => ({
          id: each.id || '',
          startDate: each?.startDate || '',
          endDate: each?.endDate || '',
          shiftLength: each?.shiftLength,
          providerType: each?.providerType || '',
          providerCount: each?.providerCount,
          hours: each?.hours,
        }))
        ?.sort((a, b) => {
          if (a.providerType === b.providerType) {
            return (
              new Date(a?.startDate).valueOf() -
              new Date(b?.startDate).valueOf()
            );
          } else if (a.providerType?.toLowerCase() === 'physician') return -1;
          else if (a.providerType?.toLowerCase() === 'app') return 1;
          return 0;
        }) || [];
  }
  applyShiftChange(shiftInfo: ShiftProviderState['shifts']['data']) {
    this.data = this.data.map((d) => {
      let _shift = shiftInfo?.[d.id];
      if (!_shift) return d;
      return {
        ...d,
        hours: _shift.shiftLength,
        shiftLength: _shift.shiftLength,
        startDate: _shift.startDate,
        endDate: _shift.endDate,
      };
    });
    return this;
  }
  getTableData({
    shiftLength = '',
    providerType = '',
    selectedDay = '',
  }: ITableFilterParams = {}) {
    return (
      this.data
        ?.filter((d) => {
          const dt = new Date(d.startDate);
          const day = dt.getDay();
          return (
            (selectedDay === '' ? true : day === selectedDay) &&
            (providerType === '' ? true : d?.providerType === providerType) &&
            (shiftLength === '' ? true : d?.shiftLength === shiftLength)
          );
        })
        .map?.((each, index: number) => ({
          id: index,
          shiftStartDateHour: each?.startDate || '',
          shiftEndDateHour: each?.endDate || '',
          providerType: each?.providerType || '',
          shiftLength: each?.shiftLength || 0,
          providerCount: each?.providerCount || '',
          hours: each?.hours || 0,
        })) || []
    );
  }
  getSummaryData(data = this.data) {
    return data.reduce(
      (prev, curr) => {
        if (curr?.providerType?.toLowerCase?.() === 'app')
          prev.totalApp = prev.totalApp + curr.hours;
        if (curr?.providerType?.toLowerCase?.() === 'physician')
          prev.totalPhysician = prev.totalPhysician + curr.hours;
        prev.overallTotal = prev.overallTotal + curr.hours;
        return prev;
      },
      {
        totalApp: 0,
        totalPhysician: 0,
        overallTotal: 0,
      }
    );
  }
  getAllList() {
    let providerTypeList: string[] = [];
    let shiftLengthList: TScenarioDetailModel['shiftLength'][] = [];
    let dayList: number[] = [];
    this.data.forEach((each) => {
      if (
        each?.providerType &&
        !providerTypeList?.includes(each?.providerType)
      ) {
        providerTypeList.push(each?.providerType);
      }
      if (each?.shiftLength && !shiftLengthList?.includes(each?.shiftLength)) {
        shiftLengthList.push(each?.shiftLength);
      }
      let startDate = new Date(each.startDate);
      const currentDay = startDate.getDay();
      if (currentDay >= 0 && !dayList?.includes(currentDay)) {
        dayList.push(currentDay);
      }
    });
    dayList = dayList.sort();
    return {
      providerTypeList,
      shiftLengthList,
      dayList,
    };
  }
}
